// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Shared cinematic opening system for dashboard modals.
 * Scoped to content/post/offer overlays; confirmation dialogs keep their own motion.
 */
:is(
  .modal-overlay,
  .offer-modal-overlay,
  .pv-overlay,
  .apply-overlay,
  .send-post-modal-overlay,
  .pv-action-modal-overlay
) {
  isolation: isolate;
  box-sizing: border-box;
  max-width: 100vw;
  max-inline-size: 100vw;
  overscroll-behavior-x: none;
  overflow: hidden;
  animation: cuModalOverlayIn .32s ease-out both !important;
}

:is(
  .modal-overlay,
  .offer-modal-overlay,
  .pv-overlay,
  .apply-overlay,
  .send-post-modal-overlay,
  .pv-action-modal-overlay
)::before {
  content: "";
  position: absolute;
  z-index: 0;
  inset: 0;
  pointer-events: none;
  opacity: .2;
  background:
    repeating-linear-gradient(0deg, transparent 0 4px, rgba(148,169,186,.2) 5px),
    linear-gradient(90deg, transparent 42%, rgba(233,90,19,.48) 50%, transparent 58%);
  mix-blend-mode: screen;
  animation: cuModalScanner .9s cubic-bezier(.2,.8,.2,1) both;
}

:is(
  .modal-overlay,
  .offer-modal-overlay,
  .pv-overlay,
  .apply-overlay,
  .send-post-modal-overlay,
  .pv-action-modal-overlay
)::after {
  content: "";
  position: absolute;
  z-index: 0;
  top: 50%;
  left: 50%;
  width: min(760px, 88vw);
  aspect-ratio: 1;
  pointer-events: none;
  border: 1px solid rgba(233,90,19,.24);
  border-radius: 50%;
  opacity: 0;
  box-shadow:
    0 0 0 55px rgba(233,90,19,.035),
    0 0 0 110px rgba(78,119,153,.025);
  transform: translate(-50%,-50%) scale(.3);
  animation: cuModalRadar .85s .05s cubic-bezier(.16,1,.3,1) both;
}

:is(
  .modal-overlay > .modal,
  .modal-overlay > .post-modal,
  .offer-modal-overlay > .offer-modal,
  .pv-overlay > .pv-modal,
  .apply-overlay > .apply-modal,
  .send-post-modal-overlay > .send-post-modal,
  .pv-action-modal-overlay > .pv-action-modal
) {
  z-index: 1;
  box-sizing: border-box;
  max-width: calc(100vw - 24px);
  max-inline-size: calc(100vw - 24px);
  overflow-x: hidden !important;
  overscroll-behavior-x: none;
  transform-origin: 50% 58%;
  backface-visibility: hidden;
  will-change: transform, opacity, filter, clip-path;
  animation: cuModalDeploy .68s cubic-bezier(.16,1,.3,1) both !important;
}

:is(
  .modal-overlay > .modal,
  .modal-overlay > .post-modal,
  .offer-modal-overlay > .offer-modal,
  .pv-overlay > .pv-modal,
  .apply-overlay > .apply-modal,
  .send-post-modal-overlay > .send-post-modal,
  .pv-action-modal-overlay > .pv-action-modal
)::after {
  content: "";
  position: absolute;
  z-index: 20;
  top: 0;
  left: 0;
  width: 18%;
  height: 100%;
  pointer-events: none;
  opacity: .65;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,.62), rgba(233,90,19,.18), transparent);
  filter: blur(7px);
  transform: translateX(-180%) skewX(-18deg);
  animation: cuModalLightSweep 1s .22s cubic-bezier(.2,.75,.2,1) both;
}

/* Reveal the main modal regions one after another. */
:is(
  .modal-overlay > .modal,
  .modal-overlay > .post-modal,
  .offer-modal-overlay > .offer-modal,
  .pv-overlay > .pv-modal,
  .apply-overlay > .apply-modal,
  .send-post-modal-overlay > .send-post-modal
) > * {
  animation: cuModalContentIn .45s .22s cubic-bezier(.16,1,.3,1) both;
}

:is(
  .modal-overlay > .modal,
  .modal-overlay > .post-modal,
  .offer-modal-overlay > .offer-modal,
  .pv-overlay > .pv-modal,
  .apply-overlay > .apply-modal,
  .send-post-modal-overlay > .send-post-modal
) > *:nth-child(2) { animation-delay: .28s; }
:is(
  .modal-overlay > .modal,
  .modal-overlay > .post-modal,
  .offer-modal-overlay > .offer-modal,
  .pv-overlay > .pv-modal,
  .apply-overlay > .apply-modal,
  .send-post-modal-overlay > .send-post-modal
) > *:nth-child(3) { animation-delay: .34s; }
:is(
  .modal-overlay > .modal,
  .modal-overlay > .post-modal,
  .offer-modal-overlay > .offer-modal,
  .pv-overlay > .pv-modal,
  .apply-overlay > .apply-modal,
  .send-post-modal-overlay > .send-post-modal
) > *:nth-child(n+4) { animation-delay: .4s; }

@keyframes cuModalOverlayIn {
  from { opacity: 0; backdrop-filter: blur(0); }
  to { opacity: 1; }
}

@keyframes cuModalDeploy {
  0% {
    opacity: 0;
    filter: blur(18px) saturate(.5);
    clip-path: inset(48% 8% 48% 8% round 24px);
    transform: perspective(1100px) translateY(52px) rotateX(15deg) rotateY(-6deg) scale(.72);
  }
  45% {
    opacity: 1;
    filter: blur(2px) saturate(1.25);
    clip-path: inset(0 2% round 20px);
    transform: perspective(1100px) translateY(-8px) rotateX(-2deg) rotateY(1deg) scale(1.025);
  }
  100% {
    opacity: 1;
    filter: none;
    clip-path: inset(0 round 0);
    transform: perspective(1100px) translateY(0) rotateX(0) rotateY(0) scale(1);
  }
}

@keyframes cuModalScanner {
  0% { opacity: 0; transform: translateX(-18%) rotate(4deg) scale(1.25); }
  35% { opacity: .24; }
  100% { opacity: 0; transform: translateX(18%) rotate(4deg) scale(1.25); }
}

@keyframes cuModalRadar {
  0% { opacity: .7; transform: translate(-50%,-50%) scale(.2) rotate(-25deg); }
  100% { opacity: 0; transform: translate(-50%,-50%) scale(1.32) rotate(12deg); }
}

@keyframes cuModalLightSweep {
  0% { opacity: 0; transform: translateX(-180%) skewX(-18deg); }
  20% { opacity: .68; }
  100% { opacity: 0; transform: translateX(720%) skewX(-18deg); }
}

@keyframes cuModalContentIn {
  from { opacity: 0; filter: blur(5px); transform: translateY(13px); }
  to { opacity: 1; filter: none; transform: none; }
}

@media (max-width: 600px) {
  :is(
    .modal-overlay > .modal,
    .modal-overlay > .post-modal,
    .offer-modal-overlay > .offer-modal,
    .pv-overlay > .pv-modal,
    .apply-overlay > .apply-modal,
    .send-post-modal-overlay > .send-post-modal,
    .pv-action-modal-overlay > .pv-action-modal
  ) {
    animation-duration: .58s !important;
  }

  :is(
    .modal-overlay,
    .offer-modal-overlay,
    .pv-overlay,
    .apply-overlay,
    .send-post-modal-overlay,
    .pv-action-modal-overlay
  )::after {
    width: 120vw;
  }
}

@media (prefers-reduced-motion: reduce) {
  :is(
    .modal-overlay,
    .offer-modal-overlay,
    .pv-overlay,
    .apply-overlay,
    .send-post-modal-overlay,
    .pv-action-modal-overlay,
    .modal-overlay > .modal,
    .modal-overlay > .post-modal,
    .offer-modal-overlay > .offer-modal,
    .pv-overlay > .pv-modal,
    .apply-overlay > .apply-modal,
    .send-post-modal-overlay > .send-post-modal,
    .pv-action-modal-overlay > .pv-action-modal
  ),
  :is(
    .modal-overlay,
    .offer-modal-overlay,
    .pv-overlay,
    .apply-overlay,
    .send-post-modal-overlay,
    .pv-action-modal-overlay
  )::before,
  :is(
    .modal-overlay,
    .offer-modal-overlay,
    .pv-overlay,
    .apply-overlay,
    .send-post-modal-overlay,
    .pv-action-modal-overlay
  )::after {
    animation: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/componentsL/ModalAnimations.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;;;;;;EAQE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;;;;;;;;EAQE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,oBAAoB;EACpB,WAAW;EACX;;qFAEmF;EACnF,sBAAsB;EACtB,2DAA2D;AAC7D;;AAEA;;;;;;;;EAQE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,UAAU;EACV;;qCAEmC;EACnC,yCAAyC;EACzC,+DAA+D;AACjE;;AAEA;;;;;;;;;EASE,UAAU;EACV,sBAAsB;EACtB,6BAA6B;EAC7B,mCAAmC;EACnC,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,kDAAkD;EAClD,sEAAsE;AACxE;;AAEA;;;;;;;;;EASE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,wGAAwG;EACxG,iBAAiB;EACjB,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA,qDAAqD;AACrD;;;;;;;;EAQE,mEAAmE;AACrE;;AAEA;;;;;;;qBAOqB,qBAAqB,EAAE;AAC5C;;;;;;;qBAOqB,qBAAqB,EAAE;AAC5C;;;;;;;uBAOuB,oBAAoB,EAAE;;AAE7C;EACE,OAAO,UAAU,EAAE,wBAAwB,EAAE;EAC7C,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,+BAA+B;IAC/B,0CAA0C;IAC1C,wFAAwF;EAC1F;EACA;IACE,UAAU;IACV,gCAAgC;IAChC,iCAAiC;IACjC,yFAAyF;EAC3F;EACA;IACE,UAAU;IACV,YAAY;IACZ,2BAA2B;IAC3B,2EAA2E;EAC7E;AACF;;AAEA;EACE,KAAK,UAAU,EAAE,oDAAoD,EAAE;EACvE,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE,mDAAmD,EAAE;AAC1E;;AAEA;EACE,KAAK,WAAW,EAAE,wDAAwD,EAAE;EAC5E,OAAO,UAAU,EAAE,yDAAyD,EAAE;AAChF;;AAEA;EACE,KAAK,UAAU,EAAE,0CAA0C,EAAE;EAC7D,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE,yCAAyC,EAAE;AAChE;;AAEA;EACE,OAAO,UAAU,EAAE,iBAAiB,EAAE,2BAA2B,EAAE;EACnE,KAAK,UAAU,EAAE,YAAY,EAAE,eAAe,EAAE;AAClD;;AAEA;EACE;;;;;;;;;IASE,mCAAmC;EACrC;;EAEA;;;;;;;;IAQE,YAAY;EACd;AACF;;AAEA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA+BE,0BAA0B;EAC5B;AACF","sourcesContent":["/*\n * Shared cinematic opening system for dashboard modals.\n * Scoped to content/post/offer overlays; confirmation dialogs keep their own motion.\n */\n:is(\n  .modal-overlay,\n  .offer-modal-overlay,\n  .pv-overlay,\n  .apply-overlay,\n  .send-post-modal-overlay,\n  .pv-action-modal-overlay\n) {\n  isolation: isolate;\n  box-sizing: border-box;\n  max-width: 100vw;\n  max-inline-size: 100vw;\n  overscroll-behavior-x: none;\n  overflow: hidden;\n  animation: cuModalOverlayIn .32s ease-out both !important;\n}\n\n:is(\n  .modal-overlay,\n  .offer-modal-overlay,\n  .pv-overlay,\n  .apply-overlay,\n  .send-post-modal-overlay,\n  .pv-action-modal-overlay\n)::before {\n  content: \"\";\n  position: absolute;\n  z-index: 0;\n  inset: 0;\n  pointer-events: none;\n  opacity: .2;\n  background:\n    repeating-linear-gradient(0deg, transparent 0 4px, rgba(148,169,186,.2) 5px),\n    linear-gradient(90deg, transparent 42%, rgba(233,90,19,.48) 50%, transparent 58%);\n  mix-blend-mode: screen;\n  animation: cuModalScanner .9s cubic-bezier(.2,.8,.2,1) both;\n}\n\n:is(\n  .modal-overlay,\n  .offer-modal-overlay,\n  .pv-overlay,\n  .apply-overlay,\n  .send-post-modal-overlay,\n  .pv-action-modal-overlay\n)::after {\n  content: \"\";\n  position: absolute;\n  z-index: 0;\n  top: 50%;\n  left: 50%;\n  width: min(760px, 88vw);\n  aspect-ratio: 1;\n  pointer-events: none;\n  border: 1px solid rgba(233,90,19,.24);\n  border-radius: 50%;\n  opacity: 0;\n  box-shadow:\n    0 0 0 55px rgba(233,90,19,.035),\n    0 0 0 110px rgba(78,119,153,.025);\n  transform: translate(-50%,-50%) scale(.3);\n  animation: cuModalRadar .85s .05s cubic-bezier(.16,1,.3,1) both;\n}\n\n:is(\n  .modal-overlay > .modal,\n  .modal-overlay > .post-modal,\n  .offer-modal-overlay > .offer-modal,\n  .pv-overlay > .pv-modal,\n  .apply-overlay > .apply-modal,\n  .send-post-modal-overlay > .send-post-modal,\n  .pv-action-modal-overlay > .pv-action-modal\n) {\n  z-index: 1;\n  box-sizing: border-box;\n  max-width: calc(100vw - 24px);\n  max-inline-size: calc(100vw - 24px);\n  overflow-x: hidden !important;\n  overscroll-behavior-x: none;\n  transform-origin: 50% 58%;\n  backface-visibility: hidden;\n  will-change: transform, opacity, filter, clip-path;\n  animation: cuModalDeploy .68s cubic-bezier(.16,1,.3,1) both !important;\n}\n\n:is(\n  .modal-overlay > .modal,\n  .modal-overlay > .post-modal,\n  .offer-modal-overlay > .offer-modal,\n  .pv-overlay > .pv-modal,\n  .apply-overlay > .apply-modal,\n  .send-post-modal-overlay > .send-post-modal,\n  .pv-action-modal-overlay > .pv-action-modal\n)::after {\n  content: \"\";\n  position: absolute;\n  z-index: 20;\n  top: 0;\n  left: 0;\n  width: 18%;\n  height: 100%;\n  pointer-events: none;\n  opacity: .65;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,.62), rgba(233,90,19,.18), transparent);\n  filter: blur(7px);\n  transform: translateX(-180%) skewX(-18deg);\n  animation: cuModalLightSweep 1s .22s cubic-bezier(.2,.75,.2,1) both;\n}\n\n/* Reveal the main modal regions one after another. */\n:is(\n  .modal-overlay > .modal,\n  .modal-overlay > .post-modal,\n  .offer-modal-overlay > .offer-modal,\n  .pv-overlay > .pv-modal,\n  .apply-overlay > .apply-modal,\n  .send-post-modal-overlay > .send-post-modal\n) > * {\n  animation: cuModalContentIn .45s .22s cubic-bezier(.16,1,.3,1) both;\n}\n\n:is(\n  .modal-overlay > .modal,\n  .modal-overlay > .post-modal,\n  .offer-modal-overlay > .offer-modal,\n  .pv-overlay > .pv-modal,\n  .apply-overlay > .apply-modal,\n  .send-post-modal-overlay > .send-post-modal\n) > *:nth-child(2) { animation-delay: .28s; }\n:is(\n  .modal-overlay > .modal,\n  .modal-overlay > .post-modal,\n  .offer-modal-overlay > .offer-modal,\n  .pv-overlay > .pv-modal,\n  .apply-overlay > .apply-modal,\n  .send-post-modal-overlay > .send-post-modal\n) > *:nth-child(3) { animation-delay: .34s; }\n:is(\n  .modal-overlay > .modal,\n  .modal-overlay > .post-modal,\n  .offer-modal-overlay > .offer-modal,\n  .pv-overlay > .pv-modal,\n  .apply-overlay > .apply-modal,\n  .send-post-modal-overlay > .send-post-modal\n) > *:nth-child(n+4) { animation-delay: .4s; }\n\n@keyframes cuModalOverlayIn {\n  from { opacity: 0; backdrop-filter: blur(0); }\n  to { opacity: 1; }\n}\n\n@keyframes cuModalDeploy {\n  0% {\n    opacity: 0;\n    filter: blur(18px) saturate(.5);\n    clip-path: inset(48% 8% 48% 8% round 24px);\n    transform: perspective(1100px) translateY(52px) rotateX(15deg) rotateY(-6deg) scale(.72);\n  }\n  45% {\n    opacity: 1;\n    filter: blur(2px) saturate(1.25);\n    clip-path: inset(0 2% round 20px);\n    transform: perspective(1100px) translateY(-8px) rotateX(-2deg) rotateY(1deg) scale(1.025);\n  }\n  100% {\n    opacity: 1;\n    filter: none;\n    clip-path: inset(0 round 0);\n    transform: perspective(1100px) translateY(0) rotateX(0) rotateY(0) scale(1);\n  }\n}\n\n@keyframes cuModalScanner {\n  0% { opacity: 0; transform: translateX(-18%) rotate(4deg) scale(1.25); }\n  35% { opacity: .24; }\n  100% { opacity: 0; transform: translateX(18%) rotate(4deg) scale(1.25); }\n}\n\n@keyframes cuModalRadar {\n  0% { opacity: .7; transform: translate(-50%,-50%) scale(.2) rotate(-25deg); }\n  100% { opacity: 0; transform: translate(-50%,-50%) scale(1.32) rotate(12deg); }\n}\n\n@keyframes cuModalLightSweep {\n  0% { opacity: 0; transform: translateX(-180%) skewX(-18deg); }\n  20% { opacity: .68; }\n  100% { opacity: 0; transform: translateX(720%) skewX(-18deg); }\n}\n\n@keyframes cuModalContentIn {\n  from { opacity: 0; filter: blur(5px); transform: translateY(13px); }\n  to { opacity: 1; filter: none; transform: none; }\n}\n\n@media (max-width: 600px) {\n  :is(\n    .modal-overlay > .modal,\n    .modal-overlay > .post-modal,\n    .offer-modal-overlay > .offer-modal,\n    .pv-overlay > .pv-modal,\n    .apply-overlay > .apply-modal,\n    .send-post-modal-overlay > .send-post-modal,\n    .pv-action-modal-overlay > .pv-action-modal\n  ) {\n    animation-duration: .58s !important;\n  }\n\n  :is(\n    .modal-overlay,\n    .offer-modal-overlay,\n    .pv-overlay,\n    .apply-overlay,\n    .send-post-modal-overlay,\n    .pv-action-modal-overlay\n  )::after {\n    width: 120vw;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  :is(\n    .modal-overlay,\n    .offer-modal-overlay,\n    .pv-overlay,\n    .apply-overlay,\n    .send-post-modal-overlay,\n    .pv-action-modal-overlay,\n    .modal-overlay > .modal,\n    .modal-overlay > .post-modal,\n    .offer-modal-overlay > .offer-modal,\n    .pv-overlay > .pv-modal,\n    .apply-overlay > .apply-modal,\n    .send-post-modal-overlay > .send-post-modal,\n    .pv-action-modal-overlay > .pv-action-modal\n  ),\n  :is(\n    .modal-overlay,\n    .offer-modal-overlay,\n    .pv-overlay,\n    .apply-overlay,\n    .send-post-modal-overlay,\n    .pv-action-modal-overlay\n  )::before,\n  :is(\n    .modal-overlay,\n    .offer-modal-overlay,\n    .pv-overlay,\n    .apply-overlay,\n    .send-post-modal-overlay,\n    .pv-action-modal-overlay\n  )::after {\n    animation: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
